export * from './app.reducers';
export * from './app.selectors';
export * from './app.effects';
export * from './app.actions';

import { ActionReducerMap } from '@ngrx/store';
import { AppState, appReducer } from './app.reducers';

export interface RootState {
  app: AppState;
}

export const reducers: ActionReducerMap<RootState> = {
  app: appReducer
};
